import React from 'react';
import PropTypes from 'prop-types';
import { ContentPackageGridTemplate } from './shared/ContentPackageGridTemplate';

export const ContentPackageTemplate5b = ({
  data,
  content,
  isAboveTheFold = false
}) => {
  return (
    <ContentPackageGridTemplate
      gridConfig={{
        lead: false,
        medium: [0, 1],
        small: [2, 3, 4],
        bottom: 'content_package_bottom'
      }}
      data={data}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  );
};

ContentPackageTemplate5b.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
